import domReady from '@roots/sage/client/dom-ready';
import {mainnav} from './mainnav.js';
import {mainnavPradaschier} from './mainnavPradaschier.js';
import {contentElementHelpers} from './contentElementHelpers.js';
import {contentElementAnimations} from './contentElementAnimations.js';
import {swiperSlider} from './swiperSlider.js';
import {accordionElement} from './accordionElement.js';
import {restApiPostsEvents} from './restApiPostsEvents.js';
import {restApiPostsPackages} from './restApiPostsPackages.js';
import {restApiPostsOffers} from './restApiPostsOffers.js';
import {shortcutLinksWidget} from './shortcutLinksWidget.js';
import {infoSnowRestApiData} from './infoSnowRestApiData.js';
import {webcamImage} from './webcamImage.js';
import {popupWindow} from './popupWindow.js';
import {googleReviews} from './google-reviews.js';
import {debugHelpers} from './debugHelpers.js';
import {queryLoopFilters} from './query-loop-filters.js';
import {fullscreenSlideshow} from './fullscreenSlideshow.js';
/**
 * Application entrypoint
 */
domReady(async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  mainnav();
  mainnavPradaschier();
  accordionElement();
  contentElementHelpers();
  contentElementAnimations();
  swiperSlider();
  webcamImage();
  restApiPostsEvents();
  restApiPostsPackages();
  restApiPostsOffers();
  infoSnowRestApiData();
  shortcutLinksWidget();
  popupWindow();
  googleReviews();
  queryLoopFilters();
  fullscreenSlideshow();
  debugHelpers();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
